export const DRAWER_WIDTH = 260
export const HEADER_HEIGHT = 55
export const PROFILE_POPPER_WIDTH = 320
